import React, { useState, useEffect, useContext } from 'react'
import { useParams, Link } from 'react-router-dom'
import './TestResults.css'
import parse from 'html-react-parser'
import ReactPlayer from 'react-player/lazy'

import Button from '../App/Common/Button/Button'
import MultiResult from './ResultOptions/Multi/MultiResult'
import SingleResult from './ResultOptions/Single/SingleResult'
import HorizontalTree from '../App/Common/HorizontalTree/HorizontalTree'
import FullScreenImage from '../App/Common/FullScreenImage/FullScreenImage'
import QuestionFilterCheckbox from '../App/Common/Inputs/Checkboxes/QuestionFilterCheckbox/QuestionFilterCheckbox'
import EssayResult from './ResultOptions/Essay/EssayResult'
import ShortAnswerResult from './ResultOptions/ShortAnswer/ShortAnswerResult'
import FillGapsResult from './ResultOptions/FillGaps/FillGapsResult'
import SequenceResult from './ResultOptions/Sequence/SequenceResult'
import PairsResult from './ResultOptions/Pairs/PairsResult'
import FileResult from './ResultOptions/File/FileResult'

import api from '../../Utils/Api'
import { CurrentUserContext } from '../../Contexts/CurrentUserContext'
import { JourneyContext } from '../../Contexts/JourneyContext'

const TestResults = ({ bestOnly }) => {
  const { token } = useContext(CurrentUserContext)
  const { currentPlace, breadCrumbs, setBreadCrumbs, setCurrentPlace } =
    useContext(JourneyContext)

  let params = useParams()
  let selectedTestId = parseInt(params.id)

  const [currentQuestionNumber, setCurrentQuestionNumber] = useState(0)
  const [leftColumnSize, setLeftColumnSize] = useState(undefined)
  const [questions, setQuestions] = useState(undefined)
  const [currentQuestion, setCurrentQuestion] = useState(undefined)
  const [isFilterChecked, setIsFilterChecked] = useState(false)
  const [wrongQuestions, setWrongQuestions] = useState([])
  const [parentStep, setParentStep] = useState(undefined)
  const [isPhotoOpened, setIsPhotoOpened] = useState(false)
  const [autoSystemReport, setAutoSystemReport] = useState({})
  const [typeResource, setType] = useState({})
  const [checkingStatus, setCheckingStatus] = useState(false)

  useEffect(() => {
    console.log(selectedTestId)
    if (bestOnly) {
      api
        .getTestBestResult(token, selectedTestId)
        .then((res) => {
          console.log(res)
          const orderedQuestions = res.questions.map((element, index) => {
            element.leftColumnNumber = index
            return element
          })
          setQuestions(orderedQuestions)
          setCurrentQuestion(orderedQuestions[0])
          setParentStep(res.step_id)
          setBreadCrumbs(res.parents)
          setCurrentPlace(res.parents.slice(-1)[0])
          setAutoSystemReport(res.auto_system_report)
          api.getStep(token, res.step_id).then((r) => {
            console.log(r)
            setType(r)
          })
        })
        .catch((e) => {
          console.log(e)
        })
    } else {
      api
        .getTestResult(token, selectedTestId)
        .then((res) => {
          console.log(res)
          const orderedQuestions = res.questions.map((element, index) => {
            element.leftColumnNumber = index
            return element
          })
          setQuestions(orderedQuestions)
          setCurrentQuestion(orderedQuestions[0])
          setParentStep(res.step_id)
          setBreadCrumbs(res.parents)
          setCurrentPlace(res.parents.slice(-1)[0])
          setAutoSystemReport(res.auto_system_report)
          setCheckingStatus(res.result)
          api.getStep(token, res.step_id).then((r) => {
            console.log(r)
            setType(r)
          })
        })
        .catch((e) => {
          console.log(e)
        })
    }

    return () => {
      setBreadCrumbs([])
    }
  }, [])

  // console.log(currentQuestion)
  useEffect(() => {
    if (questions?.length < 13) {
      setLeftColumnSize('thin')
    } else if (questions?.length < 22) {
      setLeftColumnSize('medium')
    } else if (questions?.length >= 22) {
      setLeftColumnSize('wide')
    }
  }, [questions])

  const skipQuestion = () => {
    if (currentQuestionNumber < questions.length - 1) {
      setCurrentQuestionNumber(currentQuestionNumber + 1)
    } else {
      setCurrentQuestionNumber(currentQuestionNumber)
    }
  }
  const returnQuestion = () => {
    if (currentQuestionNumber > 0) {
      setCurrentQuestionNumber(currentQuestionNumber - 1)
    } else {
      setCurrentQuestionNumber(currentQuestionNumber)
    }
  }

  useEffect(() => {
    if (questions) {
      setCurrentQuestion(questions[currentQuestionNumber])
    }
    return
  }, [currentQuestionNumber])

  // console.log(allAnswers)
  // console.log(Object.keys(allAnswers).includes('7'))

  useEffect(() => {
    let filteredQuestions = questions?.filter(
      (question) => question.is_correct === 0
    )
    // console.log(filteredQuestions)
    setWrongQuestions(filteredQuestions)
  }, [isFilterChecked])

  const getTestTitle = (breadCrumbs) => {
    console.log(breadCrumbs)
    // const testCrumb = breadCrumbs.find(crumb => crumb.type === 'test');
    // const exerciseCrumb = breadCrumbs.find(crumb => crumb.type === 'exercise');

    if (breadCrumbs.type === 'test') {
      return { typeText: 'Тест: ', title: breadCrumbs.title }
    } else if (breadCrumbs.type === 'exercise') {
      return { typeText: 'Упражнение: ', title: breadCrumbs.title }
    } else {
      return 'Тест'
    }
  }

  const getQuestionType = (type) => {
    switch (type) {
      case 'single':
        return <SingleResult options={currentQuestion.answers} />

      case 'multiple':
        return <MultiResult options={currentQuestion.answers} />
      case 'file':
        return (
          <FileResult
            result={currentQuestion}
            header={getTestTitle(typeResource)}
            status={checkingStatus}
          />
        )
      case 'essay':
        return (
          <EssayResult
            result={currentQuestion}
            status={checkingStatus}
            header={getTestTitle(typeResource)}
          />
        )
      case 'blanks':
        return <FillGapsResult question={currentQuestion} />
      case 'sequence':
        return <SequenceResult answer={currentQuestion.answers} />
      case 'short':
        return <ShortAnswerResult answer={currentQuestion} />
      case 'pairs':
        return <PairsResult answer={currentQuestion.answers} />
      default:
        return ''
    }
  }

  console.log(questions)
  console.log(currentQuestion)
  const [tab, setTab] = useState(false)
  const [titleTag, setTitle] = useState('_courses')
  const handleOpenTab = (title) => {
    if (title === 'Все курсы') {
      setTab(false)
      setTitle('_courses')
    } else if (title === 'Календарь') {
      setTab(true)
      setTitle('_calendar')
    } else if (title === 'Архив') {
      setTab(true)
      setTitle('_archive')
    }
  }

  console.log(getTestTitle(typeResource))

  const parseAndTruncateText = (htmlString, maxLength) => {
    const traverseAndTruncate = (domNode) => {
      if (domNode.type === 'text') {
        if (domNode.data.length > maxLength) {
          domNode.data = domNode.data.slice(0, maxLength) + '...'
        }
      } else if (domNode.children && domNode.children.length > 0) {
        domNode.children.forEach(traverseAndTruncate)
      }
    }

    const dom = parse(htmlString)
    console.log(dom)

    if (Array.isArray(dom)) {
      dom.forEach(traverseAndTruncate)
    } else {
      traverseAndTruncate(dom)
    }

    return dom
  }

  return (
    questions && (
      <div className="testResult__container">
        <div className="tab__wrap">
          <div
            className={
              'tab__btn' + (titleTag ? titleTag === '_courses' : 'true')
            }
            onClick={() => handleOpenTab('Все курсы')}
          >
            Результат
          </div>
        </div>
        <div className="openedBlock__container">
          <div className="testResult__header">
            <div>
              {getTestTitle(typeResource)?.typeText}
              <span className="question__header_title">
                {getTestTitle(typeResource)?.title}
              </span>
            </div>
            {/* <HorizontalTree type={'test'} id={selectedTestId} /> */}
            {/* <div className='resource__buttons'>
                        <div className='testResult__button backward' onClick={() => returnQuestion()}>Предыдущий вопрос</div>
                        <div className='testResult__button forward' onClick={() => skipQuestion()}>Следующий вопрос</div>
                    </div> */}
          </div>
          <div className="test__leftColumn">
            {/* <QuestionFilterCheckbox title={'Незачтенные '} setIsFilterChecked={setIsFilterChecked} /> */}
            <div
              className={`questions__container questions__container_${leftColumnSize}`}
            >
              {isFilterChecked
                ? wrongQuestions &&
                  wrongQuestions.map((question, index) => (
                    <div
                      className={`questions__number questions__number_wrong questions__number_${leftColumnSize} ${
                        currentQuestionNumber === question.leftColumnNumber
                          ? 'questions__number_currentResult'
                          : ''
                      } `}
                      key={question.id}
                      onClick={() =>
                        setCurrentQuestionNumber(question.leftColumnNumber)
                      }
                    >
                      {question.leftColumnNumber + 1}
                    </div>
                  ))
                : questions.map((question, index) => (
                    <div
                      className={`questions__number questions__number_${leftColumnSize} ${
                        question.is_correct > 50
                          ? 'questions__number_correct'
                          : question.is_correct > 0
                          ? 'questions__number_partlyCorrect'
                          : 'questions__number_wrong'
                      } ${
                        currentQuestionNumber === question.leftColumnNumber
                          ? 'questions__number_currentResult'
                          : ''
                      } `}
                      key={question.id}
                      onClick={() =>
                        setCurrentQuestionNumber(question.leftColumnNumber)
                      }
                    >
                      {question.leftColumnNumber + 1}
                    </div>
                  ))}
            </div>
          </div>
          <div className="testResult__question">
            <div className="testResult__questionContainer">
              <div className="question__title">
                {currentQuestion.leftColumnNumber + 1}.{' '}
                {currentQuestion.type === 'blanks' ? (
                  <p>Заполните правильно пропуски в тексте</p>
                ) : (
                  parseAndTruncateText(currentQuestion.text)
                )}
              </div>
              <div className="testResult__body">
                <div className="testResult__options">
                  {currentQuestion.attachment_link && (
                    <div className="question__imageContainer">
                      <div
                        className="question__imageIcon"
                        onClick={() => setIsPhotoOpened(true)}
                      />
                      <img
                        src={currentQuestion.attachment_link}
                        alt=""
                        className="question__image"
                      />
                    </div>
                  )}
                  {currentQuestion.embed_url && (
                    <ReactPlayer
                      className="question__video"
                      url={currentQuestion.embed_url}
                      controls
                      playsinline
                      volume={1}
                      muted={false}
                    />
                  )}
                  {getQuestionType(currentQuestion.type)}
                </div>
                {currentQuestion.answer_comment && (
                  <div className="testResult__comment">
                    <span>
                      <span style={{ fontWeight: 700 }}>
                        Общий комментарий учителя:
                      </span>{' '}
                      {parse(currentQuestion.answer_comment)}
                    </span>
                  </div>
                )}
                {/* {(currentQuestion.type === 'multiple' || currentQuestion.type === 'single') && currentQuestion.answers.map((option, index) => (
                            <div key={index}>
                                <div className='testResult__commentToOption' style={{ borderColor: option.weight > 0 ? '#0F9918' : '#E54545' }} >{option.text}</div>
                                {option.comment && <div style={{ padding: '0 20px' }}>{parse(option.comment)}</div>}
                            </div>
                        ))} */}
                <div className="question__endTestButton">
                  <Link to={`/resource/${parentStep}`}>
                    <Button
                      buttonText={`Вернуться к ${
                        typeResource.type === 'exercise'
                          ? 'упражнению'
                          : 'тесту'
                      }`}
                      type={'blank'}
                      color={'#EAECF7'}
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
          {isPhotoOpened && (
            <FullScreenImage
              image={currentQuestion.media}
              onClose={setIsPhotoOpened}
            />
          )}
        </div>
      </div>
    )
  )
}
export default TestResults
